
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(
    ".collapsible-content-wrapper-narrow .accordion details"
  );

  accordions.forEach(function (details) {
    const summary = details.querySelector("summary");
    const content = details.querySelector(".accordion__content");

    if (!summary || !content) return;

    details.style.overflow = "hidden";
    content.style.overflow = "hidden";

    summary.addEventListener("click", function (e) {
      e.preventDefault();

      if (details.dataset.animating === "true") return;

      if (details.open) {
        closeAccordion(details, content, summary);
      } else {
        openAccordion(details, content, summary);
      }
    });
  });

  function openAccordion(details, content, summary) {
    details.dataset.animating = "true";
    details.open = true;
    summary.setAttribute("aria-expanded", "true");

    content.style.height = "0px";
    content.style.opacity = "0";
    content.style.transition = "height 0.35s ease, opacity 0.25s ease";

    requestAnimationFrame(function () {
      content.style.height = content.scrollHeight + "px";
      content.style.opacity = "1";
    });

    content.addEventListener("transitionend", function end(e) {
      if (e.propertyName !== "height") return;

      content.style.height = "auto";
      details.dataset.animating = "false";
      content.removeEventListener("transitionend", end);
    });
  }

  function closeAccordion(details, content, summary) {
    details.dataset.animating = "true";
    summary.setAttribute("aria-expanded", "false");

    content.style.height = content.scrollHeight + "px";
    content.style.opacity = "1";
    content.style.transition = "height 0.35s ease, opacity 0.25s ease";

    requestAnimationFrame(function () {
      content.style.height = "0px";
      content.style.opacity = "0";
    });

    content.addEventListener("transitionend", function end(e) {
      if (e.propertyName !== "height") return;

      details.open = false;
      content.style.height = "";
      content.style.opacity = "";
      content.style.transition = "";
      details.dataset.animating = "false";

      content.removeEventListener("transitionend", end);
    });
  }
});







// compare APP


(function () {

    // ── Scale/Balance SVG icon ──
    var ICON_SVG = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" rx="24" fill="#FFF"/>
<path d="M15 18L18 19M18 19L15 28C16.7725 29.3334 19.2287 29.3334 21.0012 28M18 19L21.0001 28M18 19L24 17M30 19L33 18M30 19L27 28C28.7725 29.3334 31.2287 29.3334 33.0012 28M30 19L33.0001 28M30 19L24 17M24 15V17M24 33V17M24 33H21M24 33H27" stroke="#3F3F46" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

  function wrapCompareButton(originalBtn) {
  if (originalBtn.dataset.wrapped) return;
  originalBtn.dataset.wrapped = 'true';

  // ── Pehle container mein saare purane custom buttons remove karo ──
  var container = originalBtn.closest('.product-form__buttons');
  if (container) {
    container.querySelectorAll('.custom-compare-btn').forEach(function(btn) {
      btn.remove();
    });
  }

  var customBtn = document.createElement('button');
  customBtn.className = 'custom-compare-btn';
  customBtn.setAttribute('aria-label', 'Add to Compare');
  customBtn.setAttribute('title', 'Add to Compare');
  customBtn.innerHTML = ICON_SVG;
  customBtn.type = 'button';

  originalBtn.parentNode.insertBefore(customBtn, originalBtn);

  customBtn.addEventListener('click', function () {
    originalBtn.click();
    customBtn.classList.toggle('is-added');
  });
}

    function init() {
      document.querySelectorAll('.coder-compareder-compare.coder-compare-button')
        .forEach(wrapCompareButton);

      // Dynamically load hone wale buttons ke liye
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('.coder-compareder-compare.coder-compare-button')) {
              wrapCompareButton(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('.coder-compareder-compare.coder-compare-button')
                .forEach(wrapCompareButton);
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

  })();